// DeviceInfoDisplay.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

const DeviceInfoDisplay = ({ deviceData }) => {
  if (!deviceData) return null;

  const deviceInfoConfig = [
    { label: 'Device ID', value: deviceData.DeviceID },
    { label: 'Status', value: deviceData.DeviceStatusLabel },
    { label: 'Type', value: deviceData.DeviceTypeLabel },
    { label: 'Domain Type', value: deviceData.DeviceDomainAssigmentLabel },
    { label: 'Device GUID', value: deviceData.DeviceGuid },
    { label: 'Premises', value: deviceData.Premises },
  ];

  return (
    <Box className="p-4 w-full rounded-md">
      <Typography variant="h6" gutterBottom>
        Device Information
      </Typography>
      {deviceInfoConfig.map((info, index) => (
        <Typography key={index} variant="body2">
          <strong>{info.label}:</strong> {info.value}
        </Typography>
      ))}
    </Box>
  );
};

export default DeviceInfoDisplay;
